module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget widget-shadow widget-pricing-plan-table"
  }, [_c('div', {
    staticClass: "widget-content bg-blue-grey-600"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table margin-bottom-0"
  }, [_c('thead', {
    staticClass: "bg-blue-grey-700"
  }, [_c('tr', [_c('th', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.$t("title.DataTransfer")))]), _vm._v(" "), _c('th', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.$t("title.cost")))]), _vm._v(" "), _c('th', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.$t("title.FreeStorage")))])])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 bottom-pricing-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "counter counter-md text-left"
  }, [_c('div', {
    staticClass: "counter-label blue-grey-300"
  }, [_vm._v(_vm._s(_vm.$t("text.additional")) + " Storage")]), _vm._v(" "), _c('div', {
    staticClass: "counter-number font-size-14 white"
  }, [_vm._v("6 THB / GB / " + _vm._s(_vm.$t("unit.month")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "counter counter-md text-left"
  }, [_c('div', {
    staticClass: "counter-label blue-grey-300"
  }, [_vm._v(_vm._s(_vm.$t("title.QoderVODEncoding")))]), _vm._v(" "), _c('div', {
    staticClass: "counter-number font-size-14 white"
  }, [_vm._v("0.50 THB / " + _vm._s(_vm.$t("unit.minute")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "counter counter-md text-left bg-blue-grey-700"
  }, [_c('div', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.$t("title.pricePlanVat")))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "bg-white"
  }, [_c('tr', [_c('td', [_vm._v("0 - 500 GB")]), _vm._v(" "), _c('td', [_vm._v("1.50 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("5 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("500 GB - 1 TB")]), _vm._v(" "), _c('td', [_vm._v("1.20 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("10 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 - 3 TB")]), _vm._v(" "), _c('td', [_vm._v("1.33 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("20 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 - 5 TB")]), _vm._v(" "), _c('td', [_vm._v("1.30 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("40 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5 - 10 TB")]), _vm._v(" "), _c('td', [_vm._v("1.08 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("60 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10 - 20 TB")]), _vm._v(" "), _c('td', [_vm._v("1.00 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("100 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("20 - 40 TB")]), _vm._v(" "), _c('td', [_vm._v("0.80 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("200 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("40 - 50 TB")]), _vm._v(" "), _c('td', [_vm._v("0.70 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("300 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("50 - 60 TB")]), _vm._v(" "), _c('td', [_vm._v("0.60 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("500 GB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("60 - 70 TB")]), _vm._v(" "), _c('td', [_vm._v("0.50 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("1 TB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("70 - 100 TB")]), _vm._v(" "), _c('td', [_vm._v("0.30 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("1.5 TB")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> 100 GB")]), _vm._v(" "), _c('td', [_vm._v("0.30 THB/GB")]), _vm._v(" "), _c('td', {
    staticClass: "green-600"
  }, [_vm._v("2 TB")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21337ee8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/pricingPlan/Year2015PricingPlan.vue
// module id = 514
// module chunks = 1